var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeworkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8.198,
    style: {
      fill: "#CFDCE5"
    },
    width: 370.957,
    height: 495.607
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EBFED"
    },
    d: "M432.203,93.909l39.898-85.711l39.898,85.711v385.139c0,13.673-11.083,24.756-24.756,24.756h-30.286 c-13.673,0-24.756-11.083-24.756-24.756V93.909H432.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6F52"
    },
    d: "M511.996,438.44v40.606c0,13.671-11.086,24.757-24.757,24.757h-30.287 c-13.671,0-24.744-11.086-24.744-24.757V438.44H511.996z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.027,
    y: 93.909,
    style: {
      fill: "#97E1F7"
    },
    width: 14.845,
    height: 344.529
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3BA4BC"
    },
    d: "M432.203,479.048c0,13.673,11.083,24.756,24.756,24.756h7.55c-6.855,0-12.414-11.083-12.414-24.756 V93.909l20.007-85.711l-39.898,85.711V479.048z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCD577"
    },
    points: "511.996,93.91 432.208,93.91 472.096,8.195 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25749"
    },
    d: "M464.512,503.802h-7.559c-13.671,0-24.744-11.086-24.744-24.757V438.44h19.882v40.606 C452.09,492.717,457.657,503.802,464.512,503.802z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC36E"
    },
    points: "452.09,93.91 432.208,93.91 472.096,8.195 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.199,
    y: 429.156,
    style: {
      fill: "#FCD577"
    },
    width: 79.801,
    height: 18.558
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.918,
    y: 72.858,
    style: {
      fill: "#415E72"
    },
    width: 217.12,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.279,
    y: 168.287,
    style: {
      fill: "#415E72"
    },
    width: 56.291,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.393,
    y: 168.287,
    style: {
      fill: "#415E72"
    },
    width: 209.511,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.393,
    y: 264.395,
    style: {
      fill: "#415E72"
    },
    width: 278.177,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.681,
    y: 216.341,
    style: {
      fill: "#415E72"
    },
    width: 202.892,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.393,
    y: 216.341,
    style: {
      fill: "#415E72"
    },
    width: 62.912,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.393,
    y: 408.556,
    style: {
      fill: "#415E72"
    },
    width: 278.177,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.154,
    y: 360.502,
    style: {
      fill: "#415E72"
    },
    width: 80.416,
    height: 18.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.393,
    y: 360.502,
    style: {
      fill: "#415E72"
    },
    width: 185.385,
    height: 18.558
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeworkIcon);
export default __webpack_public_path__ + "static/media/homework-icon.b65482472814986643b656dddd313703.svg";
export { ForwardRef as ReactComponent };